import { ScrollFade as CommonScrollFade, type ScrollFadeProps } from '@monorepo/common';

function ScrollFade(props: ScrollFadeProps) {
  return <CommonScrollFade {...props} />;
}

export default ScrollFade;
